<template>
  <div class="container-fluid" v-if="cargoId">

    <div
        class="outgoing-cargo-grid"
        :class="(checkETD(getProgressOfCargo(`${cargoId}`))  ? 'etd-after' : 'etd-before')">
      <div class="cargo-status-icon">
        <cargo-status-icon :status="getProgressOfCargo(`${cargoId}`).status"
                           :etd="checkETD(getProgressOfCargo(`${cargoId}`))"/>
      </div>
      <div>
        {{ getProgressOfCargo(`${cargoId}`).reference }}
      </div>
      <div v-if="getProgressOfCargo(`${cargoId}`).startTime && getProgressOfCargo(`${cargoId}`).loaded">{{
          getProgressOfCargo(`${cargoId}`).startTime.seconds |
              firebaseTimestampTime
        }}
      </div>
      <div v-else></div>
      <div>
        <progress-bar-outgoing-cargo :cargo="getProgressOfCargo(`${cargoId}`)"
                                     :progressData="getProgressOfCargo(`${cargoId}`).progress"/>
      </div>
      <div v-if="getProgressOfCargo(`${cargoId}`).estimatedTimeOfDeparture">
        {{ formatOutgoing(getProgressOfCargo(`${cargoId}`).estimatedTimeOfDeparture) }}
        <i v-if="checkETD(getProgressOfCargo(`${cargoId}`))" class="fas fa-exclamation-triangle"/>
      </div>
    </div>

    <div class="selection-buttons">
      <button :disabled="saving || !selectedRows.length" class="btn btn-primary"
              :class="saving === 'manco' ? 'blink-button' : ''"
              @click="handleSelectedRows('manco')">
        {{
          $t(saving === 'manco' ? 'shopfloor.teamlead.orderHandling.actions.manco.busy' : 'shopfloor.teamlead.orderHandling.buttons.declareDefect')
        }}
      </button>
      <button :disabled="selectedDoneRows() || saving || !selectedRows.length"
              class="btn btn-primary"
              :class="saving === 'unload' ? 'blink-button' : ''"
              @click="handleSelectedRows('unload')">
        {{ $t('shopfloor.teamlead.orderHandling.buttons.unload') }}

      </button>
    </div>
    <div class="table-responsive">
      <datatables
          :columns="getColumns()"
          ref="orderHandlingTable"
          :rows="getProductsWithCargoAndOrder"
          :tableClass="tableClass"
          :tableInitOptions="tableInitOptions"
          deleteClass="delete"
          :customFilters="customFilters"
          tableID="order-handling-dt"
          v-if="getProductsWithCargoAndOrder"
      />
    </div>
    <div class="invisibleClicker" id="emptyCheckbox" @click="selectRow($event)"></div>
    <th class="invisibleClicker" id="emptyClicker" @click="selectAll($event)">
      <div class="custom-control custom-checkbox"><input type="checkbox" id="select-all-checkbox"
                                                         class="custom-control-input"><label
          class="custom-control-label" for="select-all-checkbox">&nbsp;</label></div>
    </th>
  </div>
</template>


<script>
import {mapActions, mapGetters} from 'vuex';
import dataTables from '../../mixins/datatables';
import ProgressBarOutgoingCargo from "@/components/ProgressBarOutgoingCargo";
import CargoStatusIcon from "@/components/CargoStatusIcon";

let INTERVAL;
export default {
  name: 'missing-goods',
  components: {
    ProgressBarOutgoingCargo,
    CargoStatusIcon
  },
  mixins: [dataTables],
  data() {
    return {
      cargoId: null,
      currentTime: moment(),
      saving: null,
      masterCheckbox: undefined,
      selectedRows: [],
      maxSelectedWithoutFilter: 200,
      defaultSelected: {
        truck: undefined,
        trailer: undefined,
        date: undefined
      },
      searchTruck: '',
      searchCustomer: '',
      searchTrailerNumber: '',
      selectedDate: new Date(),
      filterOpen: false,
      filterOpenClass: 'm-hide-lg',
      tableClass: 'table-striped table-bordered     responsive nowrap',
      tableInitOptions: {
        stateSave: true,
        language: {
          "lengthMenu": "_MENU_ resultaten weergeven",
          "zeroRecords": "Geen resultaten gevonden",
          "infoEmpty": "Geen resultaten om weer te geven",
          "search": "Zoeken:",
          "emptyTable": "Geen resultaten aanwezig in de tabel",
          "infoThousands": ".",
          "loadingRecords": "Een moment geduld aub - bezig met laden...",
          "paginate": {
            "first": "Eerste",
            "last": "Laatste",
            "next": "Volgende",
            "previous": "Vorige"
          },
          "aria": {
            "sortAscending": ": activeer om kolom oplopend te sorteren",
            "sortDescending": ": activeer om kolom aflopend te sorteren"
          },
          "autoFill": {
            "fill": "Vul alle cellen met <i>%d</i>",
            "fillHorizontal": "Vul cellen horizontaal",
            "fillVertical": "Vul cellen verticaal"
          },
          "buttons": {
            "collection": "Collectie",
            "colvis": "Kolom zichtbaarheid",
            "colvisRestore": "Herstel zichtbaarheid",
            "copy": "Kopieer",
            "copySuccess": {
              "1": "1 regel naar klembord gekopieerd",
              "_": "%ds regels naar klembord gekopieerd"
            },
            "copyTitle": "Kopieer naar klembord",
            "csv": "CSV",
            "excel": "Excel",
            "pageLength": {
              "-1": "Toon alle regels",
              "_": "Toon %d regels"
            },
            "pdf": "PDF",
            "print": "Print"
          },
          "info": "_START_ tot _END_ van _TOTAL_ regels",
          "infoFiltered": " (gefilterd uit _MAX_ regels)",
          "processing": "Verwerken..."
        },
        drawCallback: this.afterDraw,
        select: true,
        pageLength: 25,
        order: [[3, 'desc']]
      },
      customFilters: []
    };
  },
  computed: {
    ...mapGetters('outgoingCargoProgress', ['getProgressOfCargo']),
    ...mapGetters('orders', ['getOrdersFromCargo']),
    ...mapGetters('pickLocations', ['getPickLocationsOfCargo']),
    ...mapGetters('deviationFixerQueue', ['getDeviationFixerQueue']),
    ...mapGetters('users', ['getMeBasic']),
    ...mapGetters('orderProducts', ['getProductsFromCargo']),
    ...mapGetters('batchUnload', ['getBatchUnloads']),
    ...mapGetters('incomingCargo', ['getIncomingCargos']),
    ...mapGetters('deviations', ['getDeviationsOfOrder']),
    ...mapGetters('incomingOrderProducts', ['getProducts', 'getProduct']),
    ...mapGetters('incomingOrders', ['getOrders']),
    getProductsWithCargoAndOrder() {
      const mergedProperties = _.map(this.getProducts, notPickedOrderProduct => {
        notPickedOrderProduct.cargo = _.find(this.getIncomingCargos, cargo => {
          return cargo.id === notPickedOrderProduct.cargoId;
        });
        notPickedOrderProduct.order = _.find(this.getOrders, order => {
          return order.id === notPickedOrderProduct.incomingOrderId;
        });
        notPickedOrderProduct.deviations = this.getDeviationsOfOrder(notPickedOrderProduct.incomingOrderId)
        return notPickedOrderProduct;
      });
      return _.filter(mergedProperties, orderProduct => {
        return !this.isFullyPicked(orderProduct.amountUnloaded, orderProduct.amount);
      });
    }
  },
  methods: {
    ...mapActions('incomingOrderProducts', [
      'updateAmountLocally'
    ]),
    isFullyPicked(amountUnloaded, amount) {
      let amountDone = 0;
      if (amountUnloaded) {
        amountDone = amountUnloaded;
      }
      return amountDone == amount;
    },
    formatOutgoing(departure) {
      return moment(departure.toDate()).format('DD/MM HH:mm')
    },
    checkETD(outgoing) {
      let now = this.currentTime;
      if (now && outgoing.estimatedTimeOfDeparture)
        return now.isAfter(moment(outgoing.estimatedTimeOfDeparture.toDate())) && outgoing.status != 'done';
    },
    create_UUID() {
      let dt = new Date().getTime();
      let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = (dt + Math.random() * 16) % 16 | 0;
        dt = Math.floor(dt / 16);
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
      });
      return uuid;
    },
    handleSelectedRows(action) {
      const html = this.$root.$t('shopfloor.teamlead.orderHandling.actions.' + action + '.message').replace('[AMOUNT]', `<b>${this.selectedRows.length}</b>`)
      this.$swal({
        customClass: 'm-swal-load-unload',
        width: '80%',
        allowEscapeKey: false,
        allowOutsideClick: false,
        showCancelButton: true,
        title: this.$root.$t('shopfloor.teamlead.orderHandling.actions.' + action + '.title'),
        html,
        cancelButtonColor: '#d33',
        showConfirmButton: true,
        confirmButtonText: this.$root.$t('shopfloor.teamlead.orderHandling.actions.' + action + '.confirm'),
        cancelButtonText: this.$root.$t('shopfloor.teamlead.orderHandling.actions.' + action + '.cancel')
      }).then(async result => {
        if (result.value) {
          if (action === 'manco') {
            this.saving = 'manco';
            const guids = [];
            let amountToUnloadTotal = 1;
            for (let i = 0; i < this.selectedRows.length; i++) {
              const incomingProduct = this.getProduct(this.selectedRows[i]);
              if (incomingProduct.amountUnloaded == undefined || incomingProduct.amountUnloaded < incomingProduct.amount) {
                let amountToUnload = incomingProduct.amount - (incomingProduct.amountUnloaded ? incomingProduct.amountUnloaded : 0);
                amountToUnloadTotal += amountToUnload;
                const date = new Date();
                const deviationIds = [];
                for (let i = 0; i < amountToUnload; i++) {
                  let deviation = {
                    amount: 1,
                    companyId: this.getMeBasic.companyId,
                    location: 'unloading',
                    created_at: date,
                    locationAdditional: incomingProduct.productNumber,
                    userId: this.getMeBasic.userId,
                    userName: this.getMeBasic.userName,
                    recordId: incomingProduct.id,
                    orderId: incomingProduct.incomingOrderId,
                    remark: 'Gemeld via orderafhandeling',
                    type: 'shortage'
                  }
                  const devRes = await this.$FB.collection('deviations').add(deviation);
                  deviationIds.push(devRes.id);
                }
                // if (deviationIds.length) {
                //   let guid = this.create_UUID();
                //   guids.push(guid);
                //   await this.$FB.collection('deviation-fixer-queue').add({
                //     amount: amountToUnload,
                //     deviationIds: deviationIds,
                //     companyId: this.getMeBasic.companyId,
                //     location: 'unloading',
                //     guid,
                //     packingListNumber: incomingProduct.packingListNumber,
                //     uniqueIncomingProductIndex: incomingProduct.uniqueIndex,
                //     created_at: date,
                //     locationAdditional: incomingProduct.productNumber,
                //     userId: this.getMeBasic.userId,
                //     userName: this.getMeBasic.userName,
                //     recordId: incomingProduct.id,
                //     orderId: incomingProduct.incomingOrderId,
                //     remark: 'Gemeld via orderafhandeling',
                //     type: 'shortage'
                //   });
                // }
              }
            }
            this.deselectAllRows();
            const doneInterval = setInterval(() => {
              let allDone = true;
              for (let i = 0; i < guids.length; i++) {
                if (this.getDeviationFixerQueue.indexOf(guids[i]) > -1) {
                  allDone = false;
                }
              }
              if (allDone) {
                clearInterval(doneInterval);
                setTimeout(() => {
                  this.saving = null;
                  this.$swal({
                    position: 'bottom-end',
                    icon: 'success',
                    title: this.$root.$t('shopfloor.teamlead.orderHandling.actions.manco.done'),
                    showConfirmButton: false,
                    timer: 2000
                  });
                }, amountToUnloadTotal * 1000);
              }
            }, 500);
          } else if (action === 'unload') {
            this.saving = 'unload';
            let promises = []
            const guids = [];
            for (let i = 0; i < this.selectedRows.length; i++) {
              const incomingProduct = this.getProduct(this.selectedRows[i]);
              // if (incomingProduct.amountUnloaded == undefined || incomingProduct.amountUnloaded < incomingProduct.amount) {
              let guid = this.create_UUID();
              guids.push(guid);
              promises.push(this.$FB.collection('batch-unload').add({
                companyId: this.getMeBasic.companyId,
                endTime: new Date(),
                locationId: this.getMeBasic.companyId === 7 ? 1042 : 123456789,
                guid,
                barcodeUnreadable: true,
                startTime: new Date(),
                userId: this.getMeBasic.userId,
                userName: this.getMeBasic.userName,
                dateFrom: moment(incomingProduct.estimatedTimeOfArrival.toDate()).startOf('day').toDate(),
                dateTo: moment(incomingProduct.estimatedTimeOfArrival.toDate()).endOf('day').toDate(),
                type: {
                  value: incomingProduct.id,
                  key: 'id',
                }
              }));
            }
            Promise.all(promises);
            this.deselectAllRows();
            this.selectedRows = [];
            this.$swal({
              toast: true,
              position: 'bottom-end',
              icon: 'success',
              html: this.$root.$t('shopfloor.teamlead.orderHandling.actions.unload.done'),
              showConfirmButton: false,

            });
            const doneInterval = setInterval(() => {
              let allDone = true;
              for (let i = 0; i < guids.length; i++) {
                if (_.find(this.getBatchUnloads, batchUnload => { return batchUnload.guid === guids[i]})) {
                  allDone = false;
                }
              }
              if (allDone) {
                this.saving = null;
              }
            }, 500);
          }
        }
      });
    },
    deselectAllRows() {
      this.selectedRows = [];
    },
    selectedDoneRows() {
      const selectedProducts = _.filter(this.getProductsWithCargoAndOrder, (product) => {
        return _.indexOf(this.selectedRows, product.id) > -1;
      });
      // const selectedProducts = this.getProductsWithCargoAndOrder.filter(product => {
      //   return this.selectedRows.indexOf(product.id) > -1;
      // });
      return _.findIndex(selectedProducts, {'state': 'done'}) > -1;
    },
    selectRow($event) {
      const clickedId = $('#emptyCheckbox').attr('clickedId');
      const indexOfSelectedId = this.selectedRows.indexOf(clickedId);
      if (indexOfSelectedId > -1) {
        this.selectedRows.splice(indexOfSelectedId, 1);
      } else {
        this.selectedRows.push(clickedId);
      }
    },
    selectAll($event) {
      const allIds = $event.srcElement.checked ? this.$refs.orderHandlingTable.TABLE.rows({search: 'applied'}).data().map(row => row.id) : [];
      this.selectedRows = [];
      for (let i = 0; i < allIds.length; i++) {
        this.selectedRows.push(allIds[i])
      }
    },
    afterDraw() {
      const columns = $("th:contains(Auto - trailer)").parent().children();
      const checkboxElement = $('#emptyClicker').get(0);
      if (checkboxElement) {
        this.masterCheckbox = checkboxElement;
      }
      if (columns[0].innerHTML === 'Auto') {
        // Append col
        $("th:contains(Auto - trailer)").parent().children().append(this.masterCheckbox);
      } else {
        // Replace col
        $("th:contains(Auto - trailer)").parent().children().first().replaceWith(this.masterCheckbox)
      }
    },
    sortCaseInsensitive(a, b) {
      return `${a}`.toLowerCase().localeCompare(`${b}`.toLowerCase());
    },
    getColumns() {
      let self = this;
      return [
        {
          data: null,
          name: '',
          searchable: false,
          sortable: false,
          render(data) {
            const clickfunction = `$('#emptyCheckbox').attr('clickedId', '${data.id}'); $('#emptyCheckbox').click();`
            if (self.selectedRows.includes(data.id)) {
              return '<div class="custom-control custom-checkbox"><input onclick="' + clickfunction + '" value="' + data.id + '" type="checkbox" checked id="' + data.id + '" class="custom-control-input"><label class="custom-control-label" for="' + data.id + '">&nbsp;</label></div>'
            } else {
              return '<div class="custom-control custom-checkbox"><input onclick="' + clickfunction + '" value="' + data.id + '" type="checkbox" id="' + data.id + '" class="custom-control-input"><label class="custom-control-label" for="' + data.id + '">&nbsp;</label></div>'
            }
          }
        },
        {
          data: null,
          name: this.$t('shopfloor.teamlead.missingGoods.trailerTruck'),
          searchable: true,
          className: 'alignCenter',
          sortable: true,
          visible: true,
          render(data) {
            return data.cargo ? data.cargo.reference : '';
          }
        },
        {
          data: 'estimatedTimeOfArrival',
          name: this.$t('shopfloor.teamlead.missingGoods.eta'),
          searchable: true,
          className: 'alignCenter',
          sortable: true,
          visible: true,
          render(data) {
            return data ? moment(data.toDate()).format('DD/MM  HH:mm') : '';
          }
        },
        {
          data: null,
          name: this.$t('shopfloor.teamlead.missingGoods.productNumber'),
          searchable: true,
          className: 'alignCenter',
          sortable: true,
          visible: true,
          render(data) {
            return data.productNumber;
          }
        },
        {
          data: null,
          name: this.$t('shopfloor.teamlead.missingGoods.customer'),
          searchable: true,
          className: 'alignCenter',
          sortable: true,
          visible: true,
          render(data) {
            return `<div style="white-space: normal;">${data.customer}</div>`;
          }
        },
        {
          data: null,
          name: this.$t('shopfloor.teamlead.missingGoods.packingListNumber'),
          searchable: true,
          className: 'alignCenter',
          sortable: true,
          visible: true,
          render(data) {
            return data.packingListNumber
          }
        },
        {
          data: null,
          name: this.$t('shopfloor.teamlead.missingGoods.productName'),
          searchable: true,
          className: 'alignCenter',
          sortable: true,
          visible: true,
          render(data) {
            return data.productName;
          }
        },
        {
          data: null,
          name: this.$t('shopfloor.teamlead.missingGoods.progress'),
          searchable: true,
          className: 'alignCenter',
          sortable: false,
          visible: true,
          render(data) {
            let amountDone = 0;
            if (data.amountUnloaded) {
              amountDone = data.amountUnloaded;
            }
            return `${amountDone} / ${data.amount} ${data.retour ? '(r)' : ' '} ${data.deviations.length ?  '- <span class="deviations-order-product"> ' + _.sumBy(data.deviations, "amount") + ' (A) </span>' : ''}`;
          }
        },

        {
          data: null,
          name: this.$t('shopfloor.teamlead.missingGoods.truckCleared'),
          searchable: true,
          className: 'alignCenter',
          sortable: false,
          visible: true,
          render(data) {
            return data.cargo ? (data.cargo.clearedBy ? `<i class="green-check-mark fas fa-check"></i> ${data.cargo.clearedBy.userName}` : '') : '';
          }
        }
      ];
    },
    resetFilters() {
      this.selectedRows = [];
    }
    // async createView() {
    //   this.selectedRows = [];
    //   this.selectedDate = new Date();
    //   this.resetFilters();
    //   const store = ['deviationFixerQueue', 'batchUnload'];
    //   let where = [['companyId', '==', this.getMeBasic.companyId]]
    //   for (let i = 0; i < store.length; i++) {
    //     await this.$store.dispatch(store[i] + '/openDBChannel', {where})
    //   }
    //   return this.openOrderProductsDBChannel();
    // }
  }
  ,
  watch: {
    filterOpen: function (filter) {
      if (filter) {
        this.filterOpenClass = 'm-show-flex-lg';
      } else {
        this.filterOpenClass = 'm-hide-lg';
      }
    }
  },
  async beforeRouteLeave(to, from, next) {
    clearInterval(INTERVAL);
    await this.$store.dispatch('resetStoreModules', ['batchUnload', 'deviationFixerQueue', 'outgoingCargoProgress', 'orders', 'deviations', 'pickLocations', 'orderProducts', 'incomingOrderProducts', 'incomingOrders']);
    next();
  },
  async created() {
    // First we get all orders of this outgoing cargo
    // Then we get the order products of this outgoing cargo.
    // Then we get the pick locations of this outgoing cargo.
    // Then we check which (outgoing) order products don't have a pick location
    // These arent unloaded. So these are the ones we need to show.
    const params = new URLSearchParams(window.location.search)
    this.cargoId = parseInt(params.get('cargo'));
    // Outgoing cargo progess is needed to show the loading progress on top
    // Orders and picklocations are needed to figure out which is not unloaded yet
    await this.$store.dispatch('initDataForPage', [
      {module: 'outgoingCargoProgress', where: ['id', '==', this.cargoId]},
      {module: 'orders', where: ['cargoId', '==', this.cargoId]},
      {module: 'pickLocations', where: ['cargoId', '==', this.cargoId]},
      'batchUnload', 'deviationFixerQueue'
    ]);
    const openOrderProductPromises = [];
    // First get all orders of the loading cargo
    this.getOrdersFromCargo(`${this.cargoId}`).forEach(order => {
      // Then get open order products of that order
      openOrderProductPromises.push(this.$store.dispatch('initDataForPage', [
        {module: 'orderProducts', where: ['orderId', '==', parseInt(order.id)]}
      ]));
    });
    await Promise.all(openOrderProductPromises);
    // We now have: the picklocations of this cargo, the orders and the order products that are needed for loading
    const notPickedOrderProducts = _.filter(this.getProductsFromCargo(this.cargoId), orderProduct => {
      return !_.find(this.getPickLocationsOfCargo(this.cargoId), pickLocation => {
        return `${pickLocation.orderProductId}` === orderProduct.id;
      })
    });

    // Now lets open the corresponding incoming cargos, incoming orders and incoming order products
    // We connect outgoing to incoming order products by their packinglistnumber.
    const openIncomingOrderProductsPromises = [];
    notPickedOrderProducts.forEach(notPickedOrderProduct => {
      openIncomingOrderProductsPromises.push(this.$store.dispatch('initDataForPage', [
        {module: 'incomingOrderProducts', where: ['packingListNumber', '==', notPickedOrderProduct.packingListNumber]}
      ]));
    })
    await Promise.all(openIncomingOrderProductsPromises);
    const openIncomingCargoPromises = [];
    const openIncomingOrderPromises = [];
    const openDeviationPromises = [];
    this.getProducts.forEach(incomingOrderProduct => {
      openIncomingCargoPromises.push(this.$store.dispatch('initDataForPage', [
        {module: 'incomingCargo', where: ['id', '==', incomingOrderProduct.cargoId]}
      ]));
      openIncomingOrderPromises.push(this.$store.dispatch('initDataForPage', [
        {module: 'incomingOrders', where: ['id', '==', incomingOrderProduct.incomingOrderId]}
      ]));
      openDeviationPromises.push(this.$store.dispatch('initDataForPage', [
        {module: 'deviations', where: ['orderId', '==', incomingOrderProduct.incomingOrderId]}
      ]));
    });
    await Promise.all(openIncomingCargoPromises);
    await Promise.all(openIncomingOrderPromises);
    await Promise.all(openDeviationPromises);
    INTERVAL = setInterval(() => {
      this.currentTime = moment();
    }, 1000);
  }
}
;
</script>


<style lang="scss">

.outgoing-cargo-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  grid-template-rows: 1fr;
  grid-column-gap: 12px;
  grid-row-gap: 0px;
  padding: 1rem;
  margin-top: 1rem;
  font-weight: bold;
  align-items: center;
}

.align-right-div {
  text-align: right;
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.state-filter {
  display: grid;
  grid-template-columns: 13rem 2rem;;
  grid-template-rows: auto;
  grid-column-gap: 1rem;
  grid-row-gap: 0px;
}

.selection-buttons {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 1rem;
  grid-row-gap: 0px;
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.dataTable-filters {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, auto);
  grid-column-gap: 1rem;
  grid-row-gap: 1rem;
  margin: 1rem;
}

.m-hide-lg {
  visibility: hidden;
  height: 0px;
}

.container-fluid {
  margin-bottom: 15px;
}

.reset-filter-button {
  margin-right: 1rem;
}

.blink-button {
  -webkit-animation: blink 5s infinite; /* Safari 4+ */
  -moz-animation: blink 5s infinite; /* Fx 5+ */
  -o-animation: blink 5s infinite; /* Opera 12+ */
  animation: blink 5s infinite; /* IE 10+, Fx 29+ */
}

.deviation-present {
  color: red;
  font-weight: bold;
  font-size: 1.8rem;
  cursor: pointer;
}

.packingListNumber {
  align-self: center;
}

.deviationPresentContainer {
  display: grid;
  grid-template-columns: 1fr 30px;
  grid-template-rows: 1fr 0px;
  grid-column-gap: 12px;
  grid-row-gap: 0px;
}


.etd-after {
  background: #FFD8D4;
  border: 1px solid red;

}

</style>
<style>
.green-check-mark {
  color: #42dd00;
}
.deviations-order-product {
  color: red;
}
</style>


